export class CategoryInspirationResource {
    rid: number;	
	titleRo: string;
	titleEn: string;
	titleFr: string;
	titleDe: string;
	descriptionRo: string;
	descriptionEn: string;
	descriptionFr: string;
	descriptionDe: string;
	image: string;
	icon: string;
	imageString: string;
	iconString: string;
	errorCode: number;
	errorMessage: string;
}